import Token from './token'
import Form from './form'

export default {
  svg: 'workflow',
  label: 'Enroll in Workflow',
  type: 'contact',
  action: 'workflow',
  form: Form,
  token: Token
}
